import { Map } from 'immutable';

import { default as topNavigatorReducer } from './topNavigatorReducer';
import { default as notificationsMenuReducer } from '../Notifications/notificationsReducer';
import { default as lastTriggersReducer } from './lastTriggersReducer';

let defaultState = Map({
  data: Map({
    // AppTopbar common data goes here.
  })
});



export default function(state = defaultState, action) {

  state = state.set('topNavigatorData', topNavigatorReducer(state.get('topNavigatorData'), action));
  state = state.set('notificationsData', notificationsMenuReducer(state.get('notificationsData'), action));
  state = state.set('lastTriggersData', lastTriggersReducer(state.get('lastTriggersData'), action));


  switch(action.type) {

    default:
      return state;

  }

}
